import { Link } from "react-router-dom";
import img1 from "../../assets/Images/Event Booking/Complete Event List.png"
import img2 from "../../assets/Images/Reports/Event-Report.png"
import DocNavigation from "../../components/DocNavigation";

export default function OrganizedRecordKeeping() {
    return (
        <section className="space-y-16">

            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-4">
                    Organized Record Keeping
                </h1>

                <p className="text-md text-slate-600 max-w-4xl">
                    Disorganized records lead to confusion, disputes, and financial loss.
                    EventFlow ensures every booking, payment, and expense is systematically
                    recorded and easily retrievable.
                </p>

                <section className="border-l border-[#C9A24E] pl-4 mt-6">
                    <h2 className="text-lg font-semibold mb-3">Overview</h2>
                    <p className="text-slate-600 text-sm">
                        EventFlow maintains a centralized data structure that organizes
                        operational and financial records chronologically and logically.
                    </p>
                </section>
            </section>

            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-4">Common Record-keeping Issues</h3>
                <ul className="list-disc pl-5 text-slate-600 space-y-2">
                    <li>Missing invoices and receipts</li>
                    <li>Difficulty tracking historical bookings</li>
                    <li>Unclear payment histories</li>
                    <li>No audit-ready documentation</li>
                </ul>
            </section>

            <section className="p-4">
                <div>
                    <h3 className="font-semibold mb-3">
                        EventFlow’s Organized Data Structure
                    </h3>
                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Linked bookings, receipts, and invoices</li>
                        <li>Searchable customer & supplier history</li>
                        <li>Chronological event tracking</li>
                        <li>Audit-friendly documentation</li>
                    </ul>
                </div>

                <div className="rounded-lg p-6 flex items-center justify-center gap-10">
                    <img src={img1} alt="" className="w-1/2 h-auto shadow-lg" />
                    <img src={img2} alt="" className="w-1/2 h-auto shadow-lg"/>
                </div>
            </section>

            <section className="bg-slate-100 rounded-xl p-8">
                <p className="text-slate-600 max-w-4xl">
                    Organized record keeping simplifies audits, strengthens internal
                    controls, and ensures long-term data reliability.
                </p>
            </section>

            {/* <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next, learn about{" "}
                    <Link to="/docs/staff-efficiency" className="font-medium text-[#C9A24E]">
                        Staff Efficiency
                    </Link>.
                </p>
            </section> */}
 <DocNavigation
                previous={{
                    title: "Multi-user Access Control",
                    link: "/docs/access-control-bi"
                }}
                next={{
                    title: "Staff Efficiency",
                    link: "/docs/staff-efficiency"
                }}
            />

        </section>
    );
}
